<script>
  import { _ } from 'svelte-i18n';
  import { Button, Modal } from 'flowbite-svelte';
  import { PlusOutline } from 'flowbite-svelte-icons';
  import { getCookie, setCookie } from '../utils';
  import { navigate } from 'svelte-routing';
  import { onMount } from 'svelte';
  import { sendDebugEvent } from '../data/debug';

  let open = false;

  function goToCuratedBy() {
    navigate('/curated-by');
    sendDebugEvent('cb-prime-day-visit');
    handleClose();
  }

  function checkItOutLater() {
    sendDebugEvent('cb-prime-day-later');
    handleClose();
  }

  function handleClose() {
    setCookie('curatedby-prime-day', true);
    open = false;
  }

  onMount(() => {
    function init() {
      const res = getCookie('curatedby-prime-day');
      if (!res) {
        open = true;
      }
    }
    init();
  });
</script>

<Modal bind:open dismissable={false}>
  <div class="flex flex-col">
    <div class="mb-4 self-center">
      <h2
        class="rounded-md bg-[#977dff] px-3 py-1 text-xs font-semibold uppercase tracking-wider text-white sm:text-base"
      >
        {$_('cbPrimeDayModal.header', {
          default: 'Get Prime Day Ready',
        })}
      </h2>
    </div>
    <div class="mb-4 self-center">
      <h2 class="mb-2 text-center text-xl font-semibold md:text-3xl">
        {$_('cbPrimeDayModal.subtitle.p1', {
          default: 'Meet',
        })}
        <span class="font-black"
          >{$_('cbPrimeDayModal.subtitle.p2', {
            default: 'Curated',
          })}</span
        ><span class="font-black text-[#977dff]"
          >{$_('cbPrimeDayModal.subtitle.p3', {
            default: 'By.',
          })}
        </span>
      </h2>
      <p class="max-w-[40ch] text-center text-xs sm:text-base">
        {$_('cbPrimeDayModal.subtitle.text1', {
          default: 'An',
        })}
        <span class="font-bold"
          >{$_('cbPrimeDayModal.subtitle.text2', {
            default: 'automatic',
          })}</span
        >
        {$_('cbPrimeDayModal.subtitle.text3', {
          default: 'and',
        })}
        <span class="font-bold">
          {$_('cbPrimeDayModal.subtitle.text4', {
            default: 'dynamic',
          })}
        </span>
        {$_('cbPrimeDayModal.subtitle.text5', {
          default: 'link that always',
        })}
        <span class="font-bold"
          >{$_('cbPrimeDayModal.subtitle.text6', {
            default: 'stays up to date',
          })}</span
        >
        {$_('cbPrimeDayModal.subtitle.text7', {
          default: 'with your most popular products!',
        })}
      </p>
    </div>

    <div class="flex flex-col gap-2 border-t border-gray-100 py-2">
      <div class="rounded-md bg-[#F4F2FF] px-2 py-1 text-sm">
        <p class="font-semibold text-[#6660ff]">
          {$_('cbPrimeDay.callout1.title', {
            default: '🔗 One link for everything you share:',
          })}
        </p>
        <p class="text-xs sm:text-sm">
          {$_('cbPrimeDay.callout1.subtitle1', {
            default: 'Every Posttap link you create',
          })}
          <span class="font-bold"
            >{$_('cbPrimeDay.callout1.subtitle2', {
              default: 'automatically appears',
            })}
          </span>
          {$_('cbPrimeDay.callout1.subtitle3', {
            default: 'on your page.',
          })}
        </p>
      </div>
      <div class="rounded-md bg-[#F4F2FF] px-2 py-1 text-sm">
        <p class="font-semibold text-[#6660ff]">
          {$_('cbPrimeDay.callout2.title', {
            default: '🧠 Auto-organized:',
          })}
        </p>
        <p class="text-xs sm:text-sm">
          {$_('cbPrimeDay.callout2.subtitle1', {
            default: 'Your',
          })}
          <span class="font-bold"
            >{$_('cbPrimeDay.callout2.subtitle2', {
              default: 'most-clicked products',
            })}</span
          >
          {$_('cbPrimeDay.callout2.subtitle3', {
            default: 'and',
          })}
          <span class="font-bold"
            >{$_('cbPrimeDay.callout2.subtitle4', {
              default: 'recent finds rise',
            })}</span
          >
          {$_('cbPrimeDay.callout2.subtitle5', {
            default: 'to the top so',
          })}
          <span class="font-bold"
            >{$_('cbPrimeDay.callout2.subtitle6', {
              default: "followers always see what's trending...",
            })}</span
          >
        </p>
      </div>
      <div class="rounded-md bg-[#F4F2FF] px-2 py-1 text-sm">
        <p class="font-semibold text-[#6660ff]">
          {$_('cbPrimeDay.callout3.title', {
            default: '⚡️ Always fresh:',
          })}
        </p>
        <p class="text-xs sm:text-sm">
          <span class="font-bold"
            >{$_('cbPrimeDay.callout3.subtitle1', {
              default: 'No manual updates',
            })}</span
          >
          {$_('cbPrimeDay.callout3.subtitle2', {
            default: 'needed—your page keeps itself current.',
          })}
        </p>
      </div>
    </div>

    <div class="mb-1">
      <img
        class="rounded-md border border-[#6660ff]"
        src="/images/curatedby.gif"
      />
    </div>

    <div class="mb-2">
      <p class="text-center text-sm">
        <span class="font-bold">
          {$_('cbPrimeDay.caption1', {
            default: 'Make Prime Day',
          })}
          <span class="text-[#6660ff]"
            >{$_('cbPrimeDay.caption2', {
              default: 'easy',
            })}</span
          ></span
        >{$_('cbPrimeDay.caption3', {
          default: '--and keep your followers',
        })}
        <span class="font-bold"
          >{$_('cbPrimeDay.caption4', {
            default: 'coming back for more.',
          })}</span
        >
      </p>
    </div>

    <div class="flex flex-col gap-1">
      <Button
        class="flex w-full gap-1 bg-[#6660ff] text-white"
        on:click={goToCuratedBy}
      >
        <PlusOutline size="sm" />
        <span>
          {$_('cbPrimeDay.cta.goToCuratedBy', {
            default: 'Create Your Page in Seconds',
          })}
        </span>
      </Button>
      <Button
        class="w-full border border-[#6660ff] bg-white text-[#6660ff]"
        on:click={checkItOutLater}
      >
        {$_('cbPrimeDay.cta.later', {
          default: "I'll Check This Out Later",
        })}
      </Button>
    </div>
  </div>
</Modal>
